export * as encoding from './encoding'
export * as mimeTypes from './mimeTypes'
export MultiPart from './MultiPart'
export readFile from './readFile'

import HttpClient from './HttpClient'

export default HttpClient
export { HttpClient }
